import { useState } from 'react';
import { Chat, defaultTheme } from '@flyerhq/react-native-chat-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@rneui/themed';
import { Feather } from '@expo/vector-icons';
import dayjs from 'dayjs';
import OkDialog from '../components/OkDialog';

const dummyMessages = [
  {
    id: '1',
    createdAt: new Date(),
    author: {
      id: 'terapeut',
      firstName: 'Henrik',
      lastName: '',
    },
    type: 'text',
    text: 'Hello world',
  },
];

const ChatScreen = ({ addChat, chat, chatDisabledText }) => {
  const { t, i18n } = useTranslation();
  const { theme } = useTheme();
  const [showInformation, setShowInformation] = useState(chat?.length === 0);
  const [inputHeight, setInputHeight] = useState(40); // Initial height

  const handleContentSizeChange = (event) => {
    setInputHeight(event.nativeEvent.contentSize.height);
  };

  const textInputProps = {
    multiline: true,
    onContentSizeChange: handleContentSizeChange,
    style: { height: Math.max(40, inputHeight) }, // Adjust the height dynamically
  };

  const editable =
    (chat?.length === 0 || chat?.[0]?.author?.id === 'terapeut') &&
    !chatDisabledText;

  return (
    <>
      <Chat
        showUserNames={false}
        showUserAvatars={false}
        messages={chat?.map((c) => ({
          createdAt: dayjs(c.createdAt).format('YYYY-MM-DD'),
          ...c,
        }))}
        onSendPress={(m) => {
          addChat({ text: m.text });
        }}
        user={{ id: 'patient' }}
        locale={i18n?.language}
        l10nOverride={{
          inputPlaceholder: t(
            editable ? 'chat.typeMessage' : 'chat.waitingForAnswer'
          ),
        }}
        textInputProps={{
          placeholderTextColor: 'rgba(255,255,255,0.5)',
          editable,
          multiline: true,
          onContentSizeChange: handleContentSizeChange,
          style: { height: Math.max(40, inputHeight) },
        }}
        theme={{
          ...defaultTheme,
          icons: {
            sendButtonIcon: () => (
              <Feather name="send" size={26} color="white" />
            ),
          },
          colors: {
            ...defaultTheme.colors,
            inputBackground: theme.colors.primary,
            inputText: 'white',
            background: 'lightgrey',
            primary: theme.colors.primary,
          },
        }}
      />
      <OkDialog
        title={t('chat.okDialog.title')}
        body={t('chat.okDialog.body')}
        visible={showInformation}
        onOkPress={() => setShowInformation(false)}
      />
      <OkDialog
        title={t('chat.okDialog.title')}
        body={chatDisabledText}
        visible={!!chatDisabledText}
        onOkPress={() => setShowInformation(false)}
      />
    </>
  );
};

export default ChatScreen;
